import React from "react";
import { View, StyleSheet, Platform, useWindowDimensions } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
import { useThemeSettings } from "../ThemeProvider";
import { FOOTER_HEIGHT } from "../shared/constants/dimension";
import { useSafeAreaInsets } from "react-native-safe-area-context";


interface FooterNavBackgroundProps {
    height?: number;
}

export function FooterNavBackground({ height = FOOTER_HEIGHT }: FooterNavBackgroundProps) {
    const { width } = useWindowDimensions();
    const { theme } = useThemeSettings();
    const insets = useSafeAreaInsets();
    const totalHeight = height + insets.bottom;
    const notchRadius = 38;
    const notchWidth = 110;
    const center = width / 2;
    const cornerRadius = 1;

    const path = `
  M0 ${cornerRadius}
  Q0 0 ${cornerRadius} 0

  H${center - notchWidth / 2}

  C${center - notchRadius} 0
   ${center - notchRadius} ${notchRadius}
   ${center} ${notchRadius}

  C${center + notchRadius} ${notchRadius}
   ${center + notchRadius} 0
   ${center + notchWidth / 2} 0

  H${width - cornerRadius}
  Q${width} 0 ${width} ${cornerRadius}

  V${totalHeight}
  H0
  Z
`;


    return (
        <View style={[styles.container, { height: totalHeight }]}>
            <Svg width={width} height={totalHeight}>
                <Defs>
                    <LinearGradient id="footerGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <Stop offset="0%" stopColor={theme?.colors?.footerGradient1} />
                        <Stop offset="100%" stopColor={theme?.colors?.footerGradient2} />
                    </LinearGradient>
                </Defs>

                <Path d={path} fill="url(#footerGradient)" />
            </Svg>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        position: Platform.OS === "web" ? "fixed" : "absolute",
        bottom: 0,
        left: 0,
        right: 0,
    },
});
